import { ActivityStreamItemEventType } from '../models/activity-stream-event-type.enum';

export const ACTIVITY_STREAM_TITLE_UI_MAPPING = {
  [ActivityStreamItemEventType.SpecialPaymentApproval]: 'activity-stream.information-changed',
  [ActivityStreamItemEventType.PositionRequest]: 'activity-stream.information-changed',
  [ActivityStreamItemEventType.EvaluationMemberMassUpdate]: 'activity-stream.information-changed'
};
